import './helpers.js';
import { e as registerComponent, u as use } from './plugins-3ca59bb1.js';
import './Icon-6a531a4a.js';
import './FormElementMixin-19da018e.js';
import { _ as __vue_component__ } from './Select-6a270a1e.js';
export { _ as OSelect } from './Select-6a270a1e.js';

const Plugin = {
  install(Vue) {
    registerComponent(Vue, __vue_component__);
  }

};
use(Plugin);

export default Plugin;
